import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  toggleAlert: Subject<{
    message?: string, position?: string,
    variant?: 'error' | 'success' | 'info' | 'warning', open: boolean,time:number
  }> = new Subject();

  constructor() {

  }

  /**
   *
   * @param message 'message to display'
   * @param position 'position to display'
   * @param variant 'variant to display'
   */
  showAlert(
    message?: string,
    variant: 'error' | 'success' | 'info' | 'warning' = 'error',
    position: string = 'top-right',time:number =3000): void {
    if (message) {
      this.toggleAlert.next({
        message, position, variant, open: true,time
      });
    }

  }

  hideAlert(message: string, position: string,
            variant: 'error' | 'success' | 'info' | 'warning',time:number =3000): void {
    this.toggleAlert.next({
      message, position, variant, open: false, time
    });
  }

}
